import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
/**
 * Pill is a type of **atom** that represents a `<p>` element.
 */
const Pill = ({ children, className, color, ...rest }) => {
    return (_jsx("p", { className: buildClassName('skyline-text-caption-2 inline-flex items-center gap-1 rounded-[14px] px-2 py-1 font-medium leading-4', {
            'bg-darker-gray/5 border-darker-gray border border-solid': color === 'darker-gray',
            'bg-markup-green/5 border-markup-green border border-solid': color === 'markup-green',
            'bg-markup-orange/5 border-markup-orange border border-solid': color === 'markup-orange',
            'bg-markup-red/5 border-markup-red border border-solid': color === 'markup-red',
            'bg-markup-purple/5 border-markup-purple border border-solid': color === 'markup-purple',
        }, className), ...rest, children: children }));
};
export default Pill;
//# sourceMappingURL=Pill.js.map